<div class="d-flex">
  <div class="w-75">
    <h2>Verkooporder informatie</h2>
    <div class="mb-2 w-100">
      <strong>Freshdesk ticketnummers:</strong>
      <span
        *ngFor="let freshdeskTicketNumber of freshdeskTicketNumbers"
        class="ms-2"
      >
        <a
          href="{{ freshdeskTicketNumber.toString() | freshdeskTicketLink }}"
          target="_blank"
        >
          <button
            type="button"
            class="btn btn-sm btn-outline-primary"
          >
            <i class="fa-regular fa-ticket fa-l"></i>
            {{ freshdeskTicketNumber }}
          </button>
        </a>
      </span>
    </div>
    <div class="mb-2 w-100">
      <strong>Gebruikte documenten:</strong>
      <span *ngIf="contentLinks && contentLinks.length > 0">
        <span
          *ngFor="let contentLink of getContentLinks()"
          class="ms-2"
        >
          <a
            href="{{ contentLink.fullContentPath ?? '' | verkooporderContentLink }}"
            target="_blank"
          >
            <button
              type="button"
              class="btn btn-sm btn-outline-primary"
              title="{{ contentLink.originalFilename ?? '' }}"
            >
              <i class="fa-regular fa-file fa-l"></i>
              {{ contentLink.ticketId }}
            </button>
          </a>
        </span>
      </span>
      <span
        *ngIf="!contentLinks || getContentLinks().length === 0"
        class="ms-2 text-muted"
      >
        Geen
      </span>
    </div>
    <div class="mb-2 w-100">
      <label
        for="reason"
        class="form-label"
      >
        <strong>Reden voor aanpassing</strong>
      </label>
      <select
        id="reason"
        class="form-select form-select-sm"
        [formControl]="info.controls.reason"
        [formValidity]="info.controls.reason"
        [formValidityType]="'invalid'"
        [formValidityNeedsTouch]="false"
      >
        <option
          [value]="''"
          disabled
          hidden
        >
          Selecteer een reden
        </option>
        <option [value]="'Order was goed'">Order was goed</option>
        <option [value]="'SKUs waren verkeerd'">SKUs waren verkeerd</option>
        <option [value]="'Aantallen waren verkeerd'">Aantallen waren verkeerd</option>
        <option [value]="'Step quantities klopten niet'">Step quantities klopten niet</option>
        <option [value]="'Producten uit assortiment'">Producten uit assortiment</option>
        <option [value]="'De verkooporder bevatte een INDI-special'">De verkooporder bevatte een INDI-special</option>
        <option [value]="'Overig'">Overig</option>
      </select>
      <div
        *ngIf="info.get('reason')?.hasError('required')"
        class="text-danger"
      >
        Reden is verplicht.
      </div>
    </div>
    <div class="mb-2 w-100">
      <label
        class="form-label"
        for="orderReference"
      >
        <strong>Orderreferentie</strong>
      </label>
      <input
        type="text"
        id="orderReference"
        class="form-control form-control-sm"
        maxlength="36"
        [formControl]="info.controls.orderReference"
        [formValidity]="info.get('orderReference')!"
        [formValidityType]="'invalid'"
        [formValidityNeedsTouch]="false"
      />
      <div
        *ngIf="info.get('orderReference')?.hasError('maxlength')"
        class="text-danger"
      >
        Orderreferentie is te lang, deze mag maximaal 36 karakters lang zijn.
      </div>
    </div>
    <div class="mb-2 w-100">
      <label
        class="form-label"
        for="note"
      >
        <strong>Notitie</strong>
      </label>
      <textarea
        type="text"
        id="note"
        class="form-control form-control-sm"
        [formControl]="info.controls.note"
        rows="3"
        maxlength="1024"
      ></textarea>
    </div>
    <div class="mb-2 w-100">
      <label
        class="form-label"
        for="fixedDeliveryDate"
      >
        <strong>Andere leverdatum</strong>
      </label>
      <input
        type="date"
        id="fixedDeliveryDate"
        class="form-control"
        [formControl]="info.controls.fixedDeliveryDate"
        [min]="datePickerMin"
        [max]="datePickerMax"
      />
      <div
        *ngIf="info.get('fixedDeliveryDate')?.invalid"
        class="text-danger"
      >
        Kies een leverdatum tussen morgen en een jaar vooruit, of laat het veld leeg voor standaard levering.
      </div>
    </div>
  </div>
</div>
